module.exports = __webpack_public_path__ + "statics/img/pic_list.png";